var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconActiveCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60041 9.52368H17.4004M6.60041 9.52368C6.04035 9.52368 5.75963 9.52368 5.54572 9.63268C5.35756 9.72855 5.20469 9.88142 5.10881 10.0696C4.99982 10.2835 4.99982 10.5637 4.99982 11.1238V16.3238C4.99982 17.4439 4.99982 18.004 5.21781 18.4319C5.40955 18.8082 5.71529 19.1142 6.09162 19.3059C6.51902 19.5237 7.07881 19.5237 8.19673 19.5237H15.8026C16.9205 19.5237 17.4795 19.5237 17.9069 19.3059C18.2832 19.1142 18.5903 18.8081 18.782 18.4318C18.9998 18.0044 18.9998 17.4453 18.9998 16.3274V11.1147C18.9998 10.5607 18.9998 10.2823 18.8914 10.0696C18.7955 9.88142 18.642 9.72855 18.4538 9.63268C18.2399 9.52368 17.9605 9.52368 17.4004 9.52368M6.60041 9.52368H4.97513C4.12603 9.52368 3.70174 9.52368 3.46076 9.37524C3.13917 9.17715 2.95684 8.81448 2.98908 8.43815C3.01326 8.15591 3.26599 7.81457 3.77228 7.13108C3.91872 6.93339 3.99195 6.83452 4.08159 6.75903C4.2011 6.65838 4.34292 6.5869 4.49494 6.55078C4.60895 6.52368 4.73133 6.52368 4.97736 6.52368H19.0217C19.2678 6.52368 19.3905 6.52368 19.5045 6.55078C19.6565 6.5869 19.7983 6.65838 19.9178 6.75903C20.0074 6.83452 20.0809 6.93293 20.2274 7.13062C20.7336 7.8141 20.9868 8.15586 21.011 8.4381C21.0432 8.81442 20.8602 9.17715 20.5386 9.37524C20.2977 9.52368 19.8724 9.52368 19.0233 9.52368H17.4004M9.99982 14.5237H13.9998",
    stroke: "#028383",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActiveCms);
export default __webpack_public_path__ + "static/media/iconActiveCMS.dd13e53429b738003e40e0105cd6d4b1.svg";
export { ForwardRef as ReactComponent };